import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectCredentialsList } from './ProjectCredentialsList';
import { SubscriptionCredentials } from './SubscriptionCredentials';

type PermissionsBackoffice = `can_manage_backoffice` | `can_manage_translations` | `can_delete_translations`;
type PermissionsOrganization =
  | `can_update_organization`
  | `can_manage_billing`
  | `can_view_users`
  | `can_create_and_delete_users`
  | `can_manage_projects`
  | `can_manage_developers`;

export type PlannerPermissions = PermissionsBackoffice | PermissionsOrganization;

interface PlannerCredentialsProps {
  id: string;
  meta: any;
  organization_id: string;
  permissions: PlannerPermissions[];
  roles: Array<`user` | `translator`>;
  projects: ProjectCredentialsList;
  subscription: SubscriptionCredentials;
}

export class PlannerCredentials extends ValueObject<PlannerCredentialsProps> {
  private constructor(props: PlannerCredentialsProps) {
    super(props);
  }

  static create(props: PlannerCredentialsProps): PlannerCredentials {
    return new PlannerCredentials(props);
  }

  test(...permissions: PlannerPermissions[]) {
    return permissions.every((permission) => this.props.permissions.includes(permission));
  }

  get organization_id(): string {
    return this.props.organization_id;
  }

  get projects(): ProjectCredentialsList {
    return this.props.projects;
  }

  get permissions(): PlannerPermissions[] {
    return this.props.permissions;
  }

  get roles(): Array<`user` | `translator`> {
    return this.props.roles;
  }

  get subscription(): SubscriptionCredentials {
    return this.props.subscription;
  }

  isStaff(asUser?: string) {
    return (!!asUser && asUser !== ``) || this.test(`can_manage_backoffice`);
  }
}
